import { IconAlertOctagon, IconAlertTriangle, IconInfoCircle, IconX } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Linkify from 'react-linkify';

import useDismissAssetAnnouncement from 'src/Hooks/Mutations/useDismissAssetAnnouncement';
import useActiveAssetAnnouncement from 'src/Hooks/Queries/useActiveAssetAnnouncement';
import { AnnouncementLevel } from 'src/types/announcement.types';

import styles from './AssetAnnouncementBanner.module.scss';

const LEVEL_ICONS: Record<AnnouncementLevel, ReactNode> = {
  [AnnouncementLevel.Info]: <IconInfoCircle size={20} />,
  [AnnouncementLevel.Warning]: <IconAlertTriangle size={20} />,
  [AnnouncementLevel.Critical]: <IconAlertOctagon size={20} />,
};

const LEVEL_CLASSNAMES: Record<AnnouncementLevel, string> = {
  [AnnouncementLevel.Info]: styles.levelInfo,
  [AnnouncementLevel.Warning]: styles.levelWarning,
  [AnnouncementLevel.Critical]: styles.levelCritical,
};

const linkifyDecorator = (href: string, text: string, key: number) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer" className={styles.link}>
    {text}
  </a>
);

const AssetAnnouncementBanner = () => {
  const { t } = useTranslation();
  const { data: announcement } = useActiveAssetAnnouncement();
  const { mutate: dismiss } = useDismissAssetAnnouncement();

  if (!announcement) return null;

  return (
    <div className={`${styles.container} ${LEVEL_CLASSNAMES[announcement.level]}`} role="status">
      {LEVEL_ICONS[announcement.level]}
      <span className={styles.message}>
        <Linkify componentDecorator={linkifyDecorator}>{announcement.message}</Linkify>
      </span>
      <button
        type="button"
        className={styles.closeButton}
        onClick={() => dismiss(announcement.id)}
        aria-label={t('announcements.close', 'Fermer')}
      >
        <IconX size={18} />
      </button>
    </div>
  );
};

export default AssetAnnouncementBanner;
